import { BTC_ETFS } from "./constantes"

// Score de Confianca do Portfolio (aba raio, Premium 4).
// Formula CANONICA: a do card em TabPremium4.js, que e a que
// o usuario ve. Em 10/10/2026 existiam TRES copias com CINCO
// divergencias entre si — o card completo, a copia Ctx sem o
// "10 +" no ramo de Sharpe positivo e com um +5 extra de
// Fibonacci, e a copia Bot sem a penalidade de concentracao,
// com divisor errado e com outras faixas de rotulo. A Bot era
// a que o chat lia: dizia 35/100 "Baixa Confianca" onde a
// tela mostrava 37 "Fraca", com Diversificacao 4/40 contra
// 1/40. Achada perguntando ao proprio chat qual linha do
// contexto dele citava o score.
//
// Tres listas diferentes de simbolos, e elas NAO sao a mesma:
// CRIPTO17 decide se a carteira e toda cripto; o mapa de
// classe agrupa 8 simbolos como BTC; e BTC_ETFS, com 5, e o
// que mede a exposicao para a penalidade de concentracao.
const CRIPTO17 = ["IBIT","FBTC","BITB","ARKB","GBTC","BTCO",
  "HODL","EZBC","ETHA","FETH","ETHW","ETHE","ETH","BSOL",
  "XRPR","GXRP","TOXR"]
const CLASSE_BTC = ["IBIT","FBTC","BITB","ARKB","GBTC",
  "BTCO","HODL","EZBC"]
const CLASSE_ETH = ["ETHA","FETH","ETHW","ETHE","ETH"]
const CLASSE_XRP = ["XRPR","GXRP","TOXR"]

const classe = (s) =>
  CLASSE_BTC.includes(s) ? "BTC" :
  CLASSE_ETH.includes(s) ? "ETH" :
  s === "BSOL" ? "SOL" :
  CLASSE_XRP.includes(s) ? "XRP" : s

export function scoreConfianca(a) {
  const lista = (a && a.etfEnriched) || []
  const pstats = (a && a.portfolioStats) || null
  const noticias = (a && a.news) || []
  const sent = a ? a.newsSentiment : null
  const tec = (a && a.portfolioTechnical) || {}
  const tv = a && a.totalValue ? a.totalValue : 0

  const uniq = new Set(lista.map(p => classe(p.symbol))).size
  const tudoCripto = lista.length > 0 &&
    lista.every(p => CRIPTO17.includes(p.symbol))
  const btcExp = lista
    .filter(p => BTC_ETFS.includes(p.symbol))
    .reduce((x, p) => x + (p.value || 0), 0)
  const btcPct = tv > 0 ? btcExp / tv : 0

  const pAtivo = Math.min(uniq * 2.5, 10)
  const pEtf = Math.min(lista.length * 0.7, 5)
  const pBonus = uniq > 2 ? 5 : uniq > 1 ? 3 : 0
  const pCripto = tudoCripto ? -5 : 0
  const pConc = btcPct > 0.6 ? -3 : btcPct > 0.5 ? -1 : 0
  const diversificacao = Math.max(0,
    Math.round(pAtivo + pEtf + pBonus + pCripto + pConc))

  const shRaw = pstats && pstats.sharpe_ratio != null
    ? pstats.sharpe_ratio : null
  const sharpe = shRaw === null ? 0 :
    shRaw >= 1 ? 30 :
    shRaw >= 0 ? Math.round(10 + shRaw * 20) :
    shRaw >= -2 ? Math.round(10 + shRaw * 5) : 0


  // o Macro era o unico dos tres pilares opcionais que
  // entrava como ZERO MEDIDO quando ausente: Sharpe e
  // Tecnico saem do divisor, ele ficava. Sem rodar a aba
  // globo o score caia de 37 para 33 e a tela mostrava
  // "Contexto Macro 0/10", que parece medicao ruim e e
  // ausencia de medicao. Corrigido em 10/10/2026.
  const macroMedido = noticias.length > 0
  const macro = !macroMedido ? 0 :
    sent === 1 ? 10 : sent === 0 ? 5 : sent === -1 ? 2 : 5

  const tecMedido = Object.keys(tec).length > 0
  // regime por alinhamento de medias: EMA9>EMA21>EMA50 com preco acima = alta,
  // inverso = baixa, resto = lateral. Mesma regra do regime_ativo das analises.
  // Antes este pilar contava ativo que subiu no ultimo pregao e chamava de regime.
  const _rg = scoreRegime(tec, lista)
  const regime = _rg.valor
  const regimePorMedias = _rg.porMedias
  let tecnico = 15
  if (tecMedido) {
    const rsis = Object.values(tec).map(t => t.rsi).filter(Boolean)
    const mRsi = rsis.length
      ? rsis.reduce((x, y) => x + y, 0) / rsis.length : null
    const bull = Object.values(tec)
      .filter(t => t.macd && t.macd.signal_label === "bullish").length
    const bear = Object.values(tec)
      .filter(t => t.macd && t.macd.signal_label === "bearish").length
    if (mRsi !== null) {
      tecnico = mRsi < 30 ? 25 : mRsi < 45 ? 20 :
        mRsi < 55 ? 15 : mRsi < 70 ? 10 : 5
    }
    if (bull > bear) tecnico = tecnico + 5
    tecnico = Math.min(tecnico, 30)
  }

  // o divisor tira da conta o que nao foi medido, em vez de
  // punir ausencia de dado. A copia Bot usava 1.3 fixo quando
  // o tecnico existia, o que punia Sharpe ausente.
    // escala unica 0 a 100: os pesos somavam 130 por heranca (40+30+30+20+10).
  // Agora 30 diversificacao, 25 Sharpe, 20 tecnico, 15 regime, 10 macro.
  const divE = Math.round(diversificacao * 30 / 40)
  const shaE = Math.round(sharpe * 25 / 30)
  const regE = regime * 15 / 20
  const tecE = Math.round(tecnico * 20 / 30)
  const divisor = ((tecMedido ? 20 : 0) +
    (shRaw === null ? 0 : 25) + 30 + (regimePorMedias ? 15 : 0) +
    (macroMedido ? 10 : 0)) / 100
  const soma = divE + (shRaw === null ? 0 : shaE) +
    (regimePorMedias ? regE : 0) + (macroMedido ? macro : 0) +
    (tecMedido ? tecE : 0)
  const total = Math.min(100, Math.round(soma / divisor))
  const rotulo = total >= 80 ? "Alta Confiança" :
    total >= 60 ? "Boa" : total >= 40 ? "Atenção" :
    total >= 25 ? "Fraca" : "Crítica"

  return {
    regimePorMedias,
    diversificacao: divE,
    sharpe: shaE,
    regime: regE,
    macro,
    tecnico: tecE,
    tecMedido,
    macroMedido,
    sharpeMedido: shRaw !== null,
    btcPct,
    divisor,
    total,
    rotulo,
  }
}

// Regime da carteira: EMA9>EMA21>EMA50 com preco acima = alta, inverso = baixa,
// resto = lateral. Sem analise tecnica carregada cai na contagem do ultimo
// pregao. UMA funcao, chamada pela lib e pelo card da ⚡ — eram duas copias.
export function scoreRegime(tec, lista) {
  const _al = t => { const v = [t && t.current_price, t && t.ema && t.ema.ema9, t && t.ema && t.ema.ema21, t && t.ema && t.ema.ema50].map(parseFloat); if (v.some(isNaN)) return null; const [c, a, b, d] = v; return (c > a && a > b && b > d) ? 1 : (c < a && a < b && b < d) ? 0 : 0.5 }
  const regs = Object.values(tec || {}).map(_al).filter(x => x !== null)
  if (regs.length) return { valor: 5 + (regs.reduce((a, b) => a + b, 0) / regs.length) * 15, porMedias: true }
  const dc = (lista || []).map(x => x.dailyChange || 0)
  const pos = dc.filter(x => x > 0).length
  return { valor: dc.length ? 5 + (pos / dc.length) * 15 : 12.5, porMedias: false }
}
